import { USER_LOG_IN, USER_LOG_OUT, PROJECT_SAVE_TO_SERVER, PROJECT_PATCH_TO_SERVER, PROJECT_DELETE_FROM_SERVER, patchUser } from '../modules/user';

import { logIn, logOut, patchSettings, createNewUserProject, patchUserProject, deleteUserProject } from '../utils/user';

import { CLOSE_LOGIN, closeLogin, checkIfUserIsLoggedIn } from '../modules/app';

import { updateProjectToProjects, removeProject, addProject } from '../modules/projects';

import { patchProject, selectProject } from '../modules/project';

import { showInfoScreen, hideInfoScreen } from '../modules/info';

import { PATCH_SETTINGS } from '../modules/data/settings';

import { setCustomItems, patchCustomItems, removeCustomItems } from '../modules/data/customs';

import { INITIAL_STATE, validateProject } from '../modules/project';

import { openDialog, ERROR_DIALOG } from '../modules/dialogs';

import { generateUid, getUIText } from '../utils/index';
import { adobeClickSaveProject, adobeLogIn } from '../utils/analytics';

export function createMiddleware() {
  return store => next => action => {
    const { type, payload } = action;
    const { project, app, translations } = store.getState();

    switch (type) {
      case PATCH_SETTINGS:
        store.dispatch(showInfoScreen(getUIText('INFO_SCREEN-SAVING', app.language, translations)));
        if(payload) {
          const items = [];
          if(payload.newItems && payload.newItems.length) {
            for(const item of payload.newItems) {
              items.push({type: 'create', file: item});
            }
          }

          if(payload.patchItems && payload.patchItems.length) {
            for(const item of payload.patchItems) {
              items.push({type: 'patch', file: item});
            }
          }

          if(payload.deletedItems && payload.deletedItems.length) {
            for(const item of payload.deletedItems) {
              items.push({type: 'delete', file: item});
            }
          }

          // TODO: progress
          patchSettings(items).then(item => {
            if(item && item.success) {
              console.log('SUCCESS --->', item);

              if(item.success.create && item.success.create.length) {
                store.dispatch(setCustomItems({data: {data: item.success.create}}));
              }
              if(item.success.patch && item.success.patch.length) {
                store.dispatch(patchCustomItems({data: item.success.patch}));
              }
              if(item.success.delete && item.success.delete.length) {
                store.dispatch(removeCustomItems({data: item.success.delete}));
                store.dispatch(validateProject());
              }
            }
            store.dispatch(hideInfoScreen());
          }).catch(err => {
            store.dispatch(hideInfoScreen());
            store.dispatch(openDialog({dialog: ERROR_DIALOG, data: err}));
          });
        }

        next(action);
        break;

      case PROJECT_SAVE_TO_SERVER:
        store.dispatch(showInfoScreen(getUIText('INFO_SCREEN-SAVING', app.language, translations)));
        let projectToBeCreated = payload && payload.project ? payload.project : project;

        projectToBeCreated = {
          ...projectToBeCreated,
          unsaved: false
        };

        createNewUserProject(projectToBeCreated).then(item => {
          if (item && item.data && item.data.data && item.data.data.id) {
            store.dispatch(updateProjectToProjects({
              ...projectToBeCreated,
              uuid: item.data.data.id
            }));
            store.dispatch(patchProject({
              unsaved: false,
              uuid: item.data.data.id
            }));
            adobeClickSaveProject(projectToBeCreated.title || projectToBeCreated.id);
          }
          if (payload && payload.success) {
            store.dispatch(payload.success());
          } 
        }).catch(err => {
          console.log(err);
          store.dispatch(hideInfoScreen());
          store.dispatch(openDialog({dialog: ERROR_DIALOG, data: err}));
        }).finally( () => {
          store.dispatch(hideInfoScreen());
        });
        break;

      case PROJECT_PATCH_TO_SERVER:
        next(action);

        store.dispatch(showInfoScreen(getUIText('INFO_SCREEN-SAVING', app.language, translations)));

        let dataToBeSaved = {
          ...project,
          unsaved: false
        };

        patchUserProject(dataToBeSaved).then(item => {
          store.dispatch(updateProjectToProjects(dataToBeSaved));
          store.dispatch(patchProject({ unsaved: false }));

          if(payload) {
            if (payload.hasOwnProperty('success')) {
              store.dispatch(payload.success());
            }
            if (payload.hasOwnProperty('id')) {
              store.dispatch(selectProject({id: payload.id, doNotSaveToProjects: true}));
            }
          }
          adobeClickSaveProject(project.title || project.id);
        }).catch(err => {
          console.log(err);
          // if (payload && payload.failed) store.dispatch(payload.failed())
          store.dispatch(hideInfoScreen());
          store.dispatch(openDialog({dialog: ERROR_DIALOG, data: err}));
        }).finally( () => {
          store.dispatch(hideInfoScreen());
        });
        break;

      case PROJECT_DELETE_FROM_SERVER:
        next(action);

        // TODO: localization
        store.dispatch(showInfoScreen(getUIText('INFO_SCREEN-SAVING', app.language, translations)));
        const id = payload ? payload.project.uuid : project.uuid;

        deleteUserProject(id).then(item => {
          store.dispatch(removeProject({ id: payload.project.id }));
          if (payload && payload.success) store.dispatch(payload.success());
        }).catch(err => {
          console.log(err);
          // if (payload && payload.failed) store.dispatch(payload.failed())
          store.dispatch(hideInfoScreen());
          store.dispatch(openDialog({dialog: ERROR_DIALOG, data: err}));
        }).finally( () => {
          store.dispatch(hideInfoScreen());
        });

        break;

      case CLOSE_LOGIN:
        next(action);
        store.dispatch(patchUser({
          logInProgress: false,
          logInError: false,
          logInErrorMsg: null
        }));
        break;

      case USER_LOG_OUT:

        store.dispatch(patchUser({ logOutProgress: true }));
        logOut().then((resultOne) => {
          // TODO:
          // ask if save unsaved projects

          const o = {
            ...INITIAL_STATE,
            name: getUIText('PROJECTS-DEFAULT_PROJECT_NAME', app.language, translations),
            id: generateUid()
          };

          next({
            ...action,
            payload: {
              username: null,
              logOutProgress: false,
            }
          });

          store.dispatch(addProject({'project': o}));
        }).catch((err) => {
          console.log(err);
          store.dispatch(openDialog({dialog: ERROR_DIALOG, data: err}));
          next({
            ...action,
            payload: {
              logOutProgress: false,
            }
          });

        });
        break;

      case USER_LOG_IN:

        store.dispatch(patchUser({ logInProgress: true }));

        logIn(payload).then((result) => {
          if (result) {
            // if login success get data from this user
            let username;
            let uid;
            if (result && result.data) {
              if (result.data.current_user) {
                if(result.data.current_user.name) {
                  username = result.data.current_user.name;
                }

                if(result.data.current_user.uid) {
                  uid = result.data.current_user.uid;
                }
                sessionStorage.setItem('logoutToken', result.data.logout_token);
                adobeLogIn();
              }
            }

            /*
            next({
              ...action,
              payload: {
                username: username,
                logInProgress: false,
                logInError: false,
                logInErrorMsg: "Username or password wrong!"
              }
            })
            */
            // store.dispatch(closeLogin())
            store.dispatch(checkIfUserIsLoggedIn({ success: closeLogin }));
          } else {
            next({
              ...action,
              payload: {
                logInProgress: false,
                logInError: false,
              }
            });
          }
        }).catch(function(error) {
          // error on login
          store.dispatch(patchUser({
            logInProgress: false,
            logInError: true,
            logInErrorMsg: error.message
          }));
        });
        break;

      default:
        next(action);
    }
  };
}
